

import { Card, Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../../utils/headerGestorConfigs'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../../../services/api';
import Loading from '../../../../../load/loading';
import LoadingShort from '../../../../../load/loadingShort';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import compressImage from '../../../../../services/compressImage';
import CloseIcon from '@mui/icons-material/Close';
import Date from '../../../../../utils/date';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Avatar } from '@material-ui/core';
import AtribuicaoQuota from './atribuicaoQuota';
import ApproveProduto from './approveProduto';
import AddCategoriaProducto from './addCategoriaProducto';
import AddTeorBaseProducto from './addTeorBaseProducto';
import VerifyPermission from '../../../../../utils/verifyPermission';


export default function Produto({ solicitacaoImportacao }) {
    const user = useSelector(state => state.account.user);
    const { id } = useParams()
    const { produtoId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loadAddImage, setLoadAddImage] = useState(false)
    const [produto, setProduto] = useState('')
    const [openImagensCapturadas, setOpenImagensCapturadas] = useState(false);


    useEffect(() => {
        api.get(`/producto/${produtoId}`)
            .then(response => {
                setProduto(response.data.producto);
            }).catch(err => { console.log(err) });
    }, [id, setProduto])

    async function postImage(e) {
        setLoadAddImage(true)
        let imageComprimida = await compressImage(e.target.files[0])

        const formData = new FormData();
        formData.append('imagem', imageComprimida);
        formData.append('productoId', produto?._id);
        formData.append('userId', user?._id);

        await api.patch(`/producto/add-image`, formData)
            .then(response => {
                setProduto(response.data.producto);
                setLoadAddImage(false)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Amostra adicionada.!' },
                });

            }).catch(err => {
                setLoadAddImage(false)
            })
    }

    const CaptureImage = () => {
        return (
            <>
                <IconButton size='large'  >
                    {loadAddImage ? <LoadingShort />
                        :
                        <label htmlFor="capitureImage" >
                            <Tooltip title="Carregar imagens da amostra">
                                <CameraAltIcon />
                            </Tooltip>
                        </label>
                    }
                </IconButton>
                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="capitureImage" style={{ display: 'none' }} onChange={postImage} />
            </>
        )
    }

    return (
        produto ?
            <>
                <Card style={{ padding: 20, position: 'relative' }}>

                    <IconButton title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => { navigate(-1) }}> <CloseIcon /></IconButton>

                    <HeaderGestorConfigs
                        menu={false}
                        configArea={''}
                        title={'PRODUTO'}
                    />

                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Estado:</strong> {produto?.status ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Nome:</strong> {produto?.nome ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Principio Activo:</strong> {produto?.principioActivo ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Forma Farmaceutica:</strong> {produto?.formaFarmaceutica ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Categória:</strong> {produto?.categoria ?? '####'}</Typography>
                    {/* <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Tipo:</strong> {produto?.tipo ?? '####'}</Typography> */}
                    {produto?.tipo !== 'Não Controlados' &&
                        <>
                            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>TeorBase:</strong> {produto?.teorBaseG ?? '####'}</Typography>
                            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Dosagem:</strong> {produto?.dosagemConcentracao ?? '####'}</Typography>
                        </>
                    }
                    {/* <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Lote:</strong> {produto?.lote ?? '####'}</Typography> */}
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Fabricante:</strong> {produto?.fabricante ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Endereço do Fabricante:</strong> {produto?.enderecoFabricante ?? '####'}</Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Fabrico:</strong> <Date date={produto?.dataFabrico} /> </Typography>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Validade:</strong> <Date date={produto?.dataValidade} /></Typography>
                    {produto?.tipo === 'Controlados' &&
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Quota:</strong> {produto?.quota ?? '####'}</Typography>
                    }

                    <CaptureImage />

                    {/* LISTA DE IMAGENS DE AMOSTRAS CAPTURADAS */}
                    <List
                        sx={{ width: '100%', minWidth: '100%', bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItemButton onClick={() => setOpenImagensCapturadas(!openImagensCapturadas)}>
                            <ListItemIcon>
                                {produto.imagens.map((foto, index) =>
                                    index < 10 &&
                                    <Avatar key={index} variant='square' id={index} src={foto} style={{ margin: 5 }} />
                                )}
                            </ListItemIcon>
                            <ListItemText primary="IMAGENS DO PRODUTO" />
                            {openImagensCapturadas ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={openImagensCapturadas} timeout="auto" unmountOnExit>
                            {produto.imagens.map((foto, index) =>
                                <div key={index} style={{ position: 'relative' }}>
                                    <img id={index} src={foto} style={{ marginBottom: 10 }} />
                                </div>
                            )}
                        </Collapse>
                    </List>
                </Card>

                {/* {(produto?.approved === false && solicitacaoImportacao.status !== 'Aprovado' && produto?.tipo !== 'Não Controlados') && */}
                {(produto?.approved === false && solicitacaoImportacao.status !== 'Aprovado') &&
                    <>
                        <br />
                        <AddCategoriaProducto
                            produto={produto}
                            setProduto={setProduto}
                        />
                        <br />
                        {(produto?.categoria && produto?.categoria !== 'Especial') &&
                            <AddTeorBaseProducto
                                produto={produto}
                                setProduto={setProduto}
                            />
                        }

                        {produto?.tipo === 'Controlados' &&
                            <>
                                <br />
                                <AtribuicaoQuota
                                    produto={produto}
                                    setProduto={setProduto}
                                />
                            </>
                        }

                        <br />
                        <VerifyPermission permissions={user?.permissions} permission={'approveProdutoListaControlados'}>
                            <ApproveProduto
                                producto={produto}
                                setProduto={setProduto}
                                solicitacaoImportacao={solicitacaoImportacao}
                            />
                        </VerifyPermission>
                    </>
                }
            </>
            :
            <Loading text={'Acarregar produto..'} />
    )
}
